<template>
  <div
    class="col-sm-12 p-0 m-0 mx-auto index-root app-shell"
    :class="{
      'app-shell--game': $route.path === '/iframeURL',
      'app-shell--home': $route.path === '/' || $route.path === '/home',
      'app-shell--auth': $route.path === '/auth/login' || $route.path === '/auth/register',
      'app-shell--lottery': isLotteryRoute,
      'col-lg-4': $route.path !== '/iframeURL',
    }"
  >
    <NavBar v-if="
      !$route.path.includes('rule') &&
      $route.path !== '/home' &&
      $route.path !== '/' &&
      $route.path !== '/auth/login' &&
      $route.path !== '/auth/register' &&
      $route.path !== '/iframeURL'
    " />
    <router-view
      :class="[
        $route.path.includes('login') ? '' : 'middle-container',
        'index-scroll-main',
      ]"
      class="position-relative"
    ></router-view>
    <Footer
      v-if="
        !$route.path.includes('rule') &&
        !$route.path.includes('live-score') &&
        !$route.path.includes('football-result') &&
        $route.path !== '/auth/login' &&
        $route.path !== '/auth/register' &&
        $route.path !== '/iframeURL'
      "
    />
    <!-- <div class="social-contacts" id="social-contacts">
            <div
                style="position: relative"
                class="cart-container"
                v-if="
                    $route.path.includes('maung-fb') ||
                    $route.path.includes('body-fb')
                "
                @click="openModalVoucher()"
            >
                <div>
                    <i class="ni ni-cart mb-2"></i>
                </div>
                <span
                    class="
                        badge badge-md badge-circle badge-floating badge-danger
                        border-white
                        cart-number
                    "
                    v-if="$route.path.includes('2d')"
                    >{{ this.$store.state.twod_slip_data.length }}</span
                >
                <span
                    class="
                        badge badge-md badge-circle badge-floating badge-danger
                        border-white
                        cart-number
                    "
                    v-if="$route.path.includes('fb')"
                    >{{ this.$store.state.fb_order.fb_matches.length }}</span
                >
                <span
                    class="
                        badge badge-md badge-circle badge-floating badge-danger
                        border-white
                        cart-number
                    "
                    v-else-if="$route.path.includes('3d')"
                    >{{ this.$store.state.threed_slip_data.length }}</span
                >
            </div>
        </div> -->

    <van-overlay :show="$store.state.isLoading">
      <div
        class="wrapper d-flex h-100vh"
        style="background: rgba(0, 0, 0, 0.8);"
      >
        <div class="loader my-auto mx-auto">

        </div>
      </div>
    </van-overlay>

    <van-overlay
      :show="showPopup"
      @click="showPopup = false"
    >
      <div
        class="wrapper col-lg-4 col-md-12 mx-auto d-flex h-100vh"
        @click.stop
      >
        <div
          class="mx-auto my-auto pt-4 px-4 pb-4"
          style="background: #FFFFFF; border-radius: 12px; border: 1px solid rgba(13, 59, 26, 0.2); box-shadow: 0 12px 32px rgba(26, 46, 31, 0.12);"
        >
          <b-carousel
            id="carousel-1"
            :interval="3000"
            controls
            fade
            style="width: 100%; height: 100%"
          >
            <b-carousel-slide
              v-for="slide in welcomeSlides"
              :key="slide"
              :img-src="slide"
            />
          </b-carousel>

          <div class="mt-3 d-flex flex-column">
            <div class="mx-auto mb-3">
              <div class="d-flex">
                <input
                  type="checkbox"
                  v-model="isHideForToday"
                  class="mb-1 mr-2 p-0 m-0"
                />
                <h3 class="text-dark text-center p-0 m-0">Hide For Today</h3>
              </div>
            </div>

            <button
              class="btn btn-primary btn-block w-25 mx-auto text-uppercase"
              style="background: #0D3B1A !important; border: none;"
              @click="closePopup()"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </van-overlay>


    <div style="position: fixed; bottom: 70px; right: 10px">
      <div
        class="wave"
        style="position: relative"
      >
        <div
          class="contact"
          @click="showContact = !showContact"
          style="
                  width: 60px;
                  height: 60px;
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  background: #E8B923;
                  position: relative;
                "
        >
          <img
            src="https://storage.googleapis.com/spacetech2/general/headphones.png"
            style="width: 40px; height: 40px"
            alt=""
          />
        </div>
        <div
          class="contacts-container"
          :class="{ show: showContact }"
        >
          <div style="display: flex; flex-direction: column; gap: 10px">
            <a
              href="https://t.me/gameautosite_bot"
              target="_blank"
            >
              <img
                style="width: 3.5rem; height: 3.5rem"
                src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/smt223_telegram.png"
                alt=""
              />
            </a>
            <a href="https://msng.link/o?959451907249=vi">
              <!-- <a href="#"> -->
              <img
                style="width: 3.5rem; height: 3.5rem;"
                src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/smt223_viber.png"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- <div>
      <FloatIcon />
    </div> -->

    <van-overlay :show="isLuckyWheel">
      <div
        class="wrapper col-8"
        @click.stop
      >
        <LuckyWheel />
      </div>
    </van-overlay>

    <audio
      ref="bgMusic"
      src="/assets/music/shwekyarphyu.mp3"
      loop
      preload="auto"
      playsinline
    ></audio>

    <button
      v-if="$route.path !== '/iframeURL'"
      type="button"
      class="site-music-toggle"
      :class="{ 'is-playing': isMusicPlaying, 'is-dragging': musicDragging }"
      :style="musicButtonStyle"
      :aria-label="isMusicPlaying ? 'Mute music' : 'Play music'"
      :title="isMusicPlaying ? 'Stop music' : 'Play music'"
      @pointerdown="onMusicPointerDown"
      @click="onMusicClick"
    >
      <i class="fas fa-music"></i>
    </button>
  </div>
</template>
<script>
import { Dialog } from 'vant';
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';
import LuckyWheel from '../frontend/components/LuckyWheel.vue';

export default {
  components: {
    LuckyWheel,
  },
  data() {
    return {
      isLuckyWheel: false,
      isHideForToday: false,
      showPopup: false,
      welcomeSlides: [],
      websiteInfo: {},
      // popUpLink: 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/banners/2025-03-07%205.36.20%E2%80%AFPM.jpg',
      showContact: false,
      interval: null,
      isMusicPlaying: false,
      musicEnabled: true,
      musicDragging: false,
      musicDragMoved: false,
      musicPos: { x: null, y: null },
      _musicUnlockBound: null,
      _musicDragBound: null,
      _musicDragEndBound: null,
      _musicDragOffset: { x: 0, y: 0 },
    };
  },
  async mounted() {
    // this.$store.commit('setLoading', true);
    this.checkPopupStatus();
    await Promise.all([this.fetchWebsiteData(), this.resolveWelcomeSlides()]);
    this.initBackgroundMusic();
    this.loadMusicButtonPosition();
    // this.$store.commit('setLoading', false);
  },
  beforeDestroy() {
    document.body.classList.remove('lottery-theme-active');
    this.teardownBackgroundMusic();
    this.endMusicDrag();
  },
  watch: {
    isLotteryRoute: {
      immediate: true,
      handler(isLottery) {
        document.body.classList.toggle('lottery-theme-active', !!isLottery);
      },
    },
    '$route.path'(path) {
      if (path === '/iframeURL') {
        this.pauseBackgroundMusic();
      } else if (this.musicEnabled) {
        this.tryPlayBackgroundMusic();
      }
    },
  },
  computed: {
    ...mapGetters(['getFBOrder']),
    isLotteryRoute() {
      const path = this.$route.path || '';
      return (
        path.includes('/user/2d')
        || path.includes('/user/3d')
        || path.includes('/user/dream-books')
      );
    },
    musicButtonStyle() {
      if (this.musicPos.x == null || this.musicPos.y == null) {
        return {};
      }
      return {
        left: `${this.musicPos.x}px`,
        top: `${this.musicPos.y}px`,
        right: 'auto',
        bottom: 'auto',
      };
    },
  },

  methods: {
    async resolveWelcomeSlides() {
      const candidates = [
        '/assets/welcome1.webp',
        '/assets/welcome2.webp',
      ];
      const checks = await Promise.all(
        candidates.map(
          (src) =>
            new Promise((resolve) => {
              const img = new Image();
              img.onload = () => resolve(src);
              img.onerror = () => resolve(null);
              img.src = src;
            })
        )
      );
      const available = checks.filter(Boolean);
      this.welcomeSlides = available.length ? available : ['/assets/12k-new.avif'];
    },
    loadMusicButtonPosition() {
      try {
        const raw = localStorage.getItem('skp_music_btn_pos');
        if (!raw) return;
        const parsed = JSON.parse(raw);
        if (
          typeof parsed.x === 'number' &&
          typeof parsed.y === 'number' &&
          Number.isFinite(parsed.x) &&
          Number.isFinite(parsed.y)
        ) {
          this.musicPos = this.clampMusicPosition(parsed.x, parsed.y);
        }
      } catch (e) {
        /* ignore */
      }
    },
    saveMusicButtonPosition() {
      if (this.musicPos.x == null || this.musicPos.y == null) return;
      try {
        localStorage.setItem(
          'skp_music_btn_pos',
          JSON.stringify({ x: this.musicPos.x, y: this.musicPos.y })
        );
      } catch (e) {
        /* ignore */
      }
    },
    clampMusicPosition(x, y) {
      const root = this.$el;
      const size = 42;
      const maxX = Math.max(0, (root ? root.clientWidth : window.innerWidth) - size);
      const maxY = Math.max(0, (root ? root.clientHeight : window.innerHeight) - size);
      return {
        x: Math.min(Math.max(0, x), maxX),
        y: Math.min(Math.max(0, y), maxY),
      };
    },
    onMusicPointerDown(event) {
      if (event.button != null && event.button !== 0) return;
      const root = this.$el;
      if (!root) return;

      const rootRect = root.getBoundingClientRect();
      const btnRect = event.currentTarget.getBoundingClientRect();
      const currentX = this.musicPos.x != null ? this.musicPos.x : btnRect.left - rootRect.left;
      const currentY = this.musicPos.y != null ? this.musicPos.y : btnRect.top - rootRect.top;

      this.musicPos = { x: currentX, y: currentY };
      this.musicDragging = true;
      this.musicDragMoved = false;
      this._musicDragOffset = {
        x: event.clientX - rootRect.left - currentX,
        y: event.clientY - rootRect.top - currentY,
      };

      if (event.currentTarget.setPointerCapture) {
        try {
          event.currentTarget.setPointerCapture(event.pointerId);
        } catch (e) {
          /* ignore */
        }
      }

      this._musicDragBound = (e) => this.onMusicPointerMove(e);
      this._musicDragEndBound = (e) => this.onMusicPointerUp(e);
      window.addEventListener('pointermove', this._musicDragBound, { passive: false });
      window.addEventListener('pointerup', this._musicDragEndBound);
      window.addEventListener('pointercancel', this._musicDragEndBound);
    },
    onMusicPointerMove(event) {
      if (!this.musicDragging) return;
      event.preventDefault();
      const root = this.$el;
      if (!root) return;
      const rootRect = root.getBoundingClientRect();
      const nextX = event.clientX - rootRect.left - this._musicDragOffset.x;
      const nextY = event.clientY - rootRect.top - this._musicDragOffset.y;
      const clamped = this.clampMusicPosition(nextX, nextY);
      if (
        Math.abs(clamped.x - this.musicPos.x) > 2 ||
        Math.abs(clamped.y - this.musicPos.y) > 2
      ) {
        this.musicDragMoved = true;
      }
      this.musicPos = clamped;
    },
    onMusicPointerUp() {
      if (!this.musicDragging) return;
      this.endMusicDrag();
      if (this.musicDragMoved) {
        this.saveMusicButtonPosition();
      }
    },
    endMusicDrag() {
      this.musicDragging = false;
      if (this._musicDragBound) {
        window.removeEventListener('pointermove', this._musicDragBound);
        this._musicDragBound = null;
      }
      if (this._musicDragEndBound) {
        window.removeEventListener('pointerup', this._musicDragEndBound);
        window.removeEventListener('pointercancel', this._musicDragEndBound);
        this._musicDragEndBound = null;
      }
    },
    onMusicClick(event) {
      if (this.musicDragMoved) {
        event.preventDefault();
        event.stopPropagation();
        this.musicDragMoved = false;
        return;
      }
      this.toggleMusic();
    },
    initBackgroundMusic() {
      try {
        this.musicEnabled = localStorage.getItem('skp_music_enabled') !== '0';
      } catch (e) {
        this.musicEnabled = true;
      }

      const audio = this.$refs.bgMusic;
      if (!audio) return;
      audio.volume = 0.45;
      audio.loop = true;

      if (this.musicEnabled && this.$route.path !== '/iframeURL') {
        this.tryPlayBackgroundMusic();
        this.bindMusicUnlock();
      }
    },
    bindMusicUnlock() {
      if (this._musicUnlockBound) return;
      this._musicUnlockBound = () => {
        if (this.musicEnabled && !this.isMusicPlaying) {
          this.tryPlayBackgroundMusic();
        }
        this.unbindMusicUnlock();
      };
      window.addEventListener('pointerdown', this._musicUnlockBound, { once: true, passive: true });
      window.addEventListener('keydown', this._musicUnlockBound, { once: true });
    },
    unbindMusicUnlock() {
      if (!this._musicUnlockBound) return;
      window.removeEventListener('pointerdown', this._musicUnlockBound);
      window.removeEventListener('keydown', this._musicUnlockBound);
      this._musicUnlockBound = null;
    },
    async tryPlayBackgroundMusic() {
      const audio = this.$refs.bgMusic;
      if (!audio || !this.musicEnabled || this.$route.path === '/iframeURL') return;
      try {
        await audio.play();
        this.isMusicPlaying = true;
      } catch (e) {
        this.isMusicPlaying = false;
        this.bindMusicUnlock();
      }
    },
    pauseBackgroundMusic() {
      const audio = this.$refs.bgMusic;
      if (!audio) return;
      audio.pause();
      this.isMusicPlaying = false;
    },
    toggleMusic() {
      this.musicEnabled = !this.musicEnabled;
      try {
        localStorage.setItem('skp_music_enabled', this.musicEnabled ? '1' : '0');
      } catch (e) {
        /* ignore */
      }

      if (this.musicEnabled) {
        this.tryPlayBackgroundMusic();
      } else {
        this.pauseBackgroundMusic();
        this.unbindMusicUnlock();
      }
    },
    teardownBackgroundMusic() {
      this.unbindMusicUnlock();
      this.pauseBackgroundMusic();
    },
    testing() {
      this.isLuckyWheel = true;
      console.log('testing');
    },
    closePopup() {
      this.showPopup = false;
      const today = new Date().toISOString().split('T')[0];
      if (this.isHideForToday)
        localStorage.setItem('popupDismissedDate', today);
    },
    checkPopupStatus() {
      const today = new Date().toISOString().split('T')[0];
      const lastDismissedDate = localStorage.getItem('popupDismissedDate');
      if (lastDismissedDate !== today) {
        this.showPopup = true;
      }
      // if(today === '2025-02-07'){
      //   this.popUpLink = 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/banners/2025-02-07%208.13.41%E2%80%AFPM.jpg';
      // } else {
      //   this.popUpLink = 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/banners/welcome.jpg'
      // }
    },

    ...mapMutations(['setWholeFBMatches', 'setContactInfo', 'setContactTelegram']),
    ...mapActions(['fetchUser']),
    closeModalOutside(event) {
      if (event.target.classList.contains('modal')) {
        this.$router.go();
      }
    },
    async fetchWebsiteData() {
      try {
        const res = await axios.get('/website-infos');
        this.websiteInfo = res.data.data[0];
        this.setContactInfo(this.websiteInfo.contact_info);
        this.setContactTelegram(
          this.websiteInfo.telegram_info
            || this.websiteInfo.contact_telegram
            || this.websiteInfo.telegram
            || this.websiteInfo.telegram_link
            || null
        );
        if (
          res.data.data[0].androidVersion !== this.$store.state.androidVersion
        ) {
          $('#version').modal('show');
        }
      } catch (error) {
        console.log(error);
      }
    },
    openModalVoucher() {
      if (this.$store.state.fb_order.fb_matches.length === 0) {
        const dataError =
          this.$store.state.language === 'en'
            ? 'Please select some teams!'
            : 'အသင်းတစ်ချို့ ရွေးပေးပါ။';
        this.dialog(dataError);
      } else {
        const matches = this.getFBOrder.fb_matches;
        if (!this.$store.state.betAmount) {
          $('#amount').modal('show');
        } else {
          for (let i = 0; i < matches.length; i += 1) {
            matches[i].bet_amount = this.$store.state.betAmount;
          }
          this.setWholeFBMatches(matches);
          $('#mobile-voucher').modal('show');
        }
      }
    },

    dialog(text) {
      Dialog.alert({
        message: text,
        confirmButtonText:
          this.$store.state.language === 'en'
            ? 'Go Back'
            : 'နောက်သို့ပြန်သွားမည်။',
      }).then(() => {
        // on close
      });
    },
  },
};
</script>
<style scoped>
.hello-world {
  background-image: #FEC8BA !important;
}


/* HTML: <div class="loader"></div> */
.loader {
  width: 50px;
  aspect-ratio: 1;
  display: grid;
  border: 4px solid #0000;
  border-radius: 50%;
  border-color: #ccc #0000;
  animation: l16 1s infinite linear;
}

.loader::before,
.loader::after {
  content: "";
  grid-area: 1/1;
  margin: 2px;
  border: inherit;
  border-radius: 50%;
}

.loader::before {
  border-color: #f03355 #0000;
  animation: inherit;
  animation-duration: .5s;
  animation-direction: reverse;
}

.loader::after {
  margin: 8px;
}

@keyframes l16 {
  100% {
    transform: rotate(1turn)
  }
}


.active-contact {
  transform: translate(0);
  transition: all 1s ease-in-out;
}

.box-contact .open-contact {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -12px;
  margin: auto;
}

.box-contact a img {
  width: 40px;
}

.box-contact {
  position: fixed;
  top: 60%;
  right: 0;
  border-radius: 12px 0 0 12px !important;
  background: #0D3B1A;
  padding: 1rem 0.5rem 1rem 1.3rem;
  transform: translate(0);
  animation: slide 2s ease-in;
  z-index: 10;
}

.van-overlay {
  background: rgba(0, 0, 0, 0.4) !important;
}

.floating {
  position: fixed;
  width: 90px;
  z-index: 1;
  animation: floating 20s infinite;
  bottom: 130px;
  right: 0%;
}

#closeButton {
  border: none;
  background: none;
  position: absolute;
  left: -15px;
  font-size: 20px;
  font-weight: bold;
  color: #b7b7b7;
}

@keyframes float {
  0% {
    transform: translatey(0px);
  }

  50% {
    transform: translatey(-20px);
  }

  100% {
    transform: translatey(0px);
  }
}

.cart-number {
  top: -2px !important;
  left: -2px !important;
}

.cart-number {
  position: absolute;
  top: -3px;
  left: -3px;
  text-align: center;
}

.site-music-toggle {
  position: absolute;
  left: 0.7rem;
  bottom: 5.4rem;
  z-index: 1100;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.6rem;
  height: 2.6rem;
  border: 1px solid rgba(255, 214, 64, 0.55);
  border-radius: 50%;
  background: #3A2A08;
  color: #ffe566;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.35);
  cursor: grab;
  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
}

.site-music-toggle.is-playing {
  color: #1a1400;
  background: #E8B923;
  border-color: #fff3a0;
  box-shadow: 0 6px 18px rgba(255, 208, 0, 0.45);
}

.site-music-toggle.is-dragging {
  cursor: grabbing;
  transform: scale(1.06);
  box-shadow: 0 10px 24px rgba(255, 208, 0, 0.35);
}

.site-music-toggle i {
  font-size: 0.95rem;
  pointer-events: none;
}

/* Flex shell: scroll lives here so content works with html/body overflow:hidden */
.index-root {
  display: flex;
  flex-direction: column;
  height: 100vh;
  max-height: 100vh;
  width: 100%;
  max-width: 100%;
  margin-left: auto !important;
  margin-right: auto !important;
  position: relative;
  overflow: hidden;
  background: #FFFFFF;
}

.index-root.app-shell--auth {
  background: #0D3B1A;
}

/* PC: keep mobile layout centered like a phone frame */
@media (min-width: 768px) {
  .index-root:not(.app-shell--game) {
    max-width: 520px;
    width: 100%;
    border-left: 1px solid rgba(13, 59, 26, 0.16);
    border-right: 1px solid rgba(13, 59, 26, 0.16);
    box-shadow:
      0 0 0 1px rgba(0, 0, 0, 0.35),
      0 18px 60px rgba(0, 0, 0, 0.55);
  }
}

/* .index-scroll-main + .middle-container: global rules in src/scss/style.scss (scoped CSS here does not apply to router-view child roots) */
@media (max-width: 768px) {
  .cart-container {
    font-size: 30px !important;
  }

  .social-contacts div {
    width: 60px !important;
    height: 60px !important;
    margin-top: 15px;
  }

  #social-contacts .badge-circle.badge-md {
    width: 1.5rem !important;
    height: 1.5rem !important;
  }

  .cart-container {
    visibility: visible;
    font-size: 16px;
  }
}

.contacts-container {
  position: absolute;
  bottom: 110%;
  left: 25%;
  opacity: 0;
  pointer-events: none;
  transform: translateY(20px) translateX(-25%);
  transition: all 0.1s ease-in-out;
}

.contacts-container.show {
  opacity: 1;
  pointer-events: all;
  transform: translateX(-25%) translateY(-10px);
}

.contact {
  animation: wave 2s linear infinite;
}

@keyframes wave {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.2);
  }
}
</style>
